import { atom } from "jotai";
import { UserPublic } from "@/app/_lib/types/user.types";

export const usersPublicAtom = atom<Record<string, UserPublic>>({});
